module.exports = __webpack_public_path__ + "media/images/emblems/Riedbrig-cca0e8189d7ca0e353638df6127fe029.png";